import Head from 'next/head';
import Layout from '../components/Layout';
import styles from '../styles/Home.module.css';

export default function Terms() {
    return (
      <Layout backgroundColor="#131f2d">
        <Head>
          <title>About Impact Theory</title>
          <meta property="og:title" content="Impact Theory Template" />
          <meta property="og:url" content="https://www.founderskey.io" />
          <meta
            property="og:image"
            content="https://impacttheory.com/wp-content/uploads/2018/11/impact-theory-logo.png"
          />
        </Head>

        <main className={styles.main}>
          <h1
            className={styles.title}
            style={{ marginTop: "100px", color: "white" }}
          >
            Impact Theory Site Terms and Terms of Sale
          </h1>
          <div
            style={{
              textAlign: "left",
              margin: "auto",
              width: "80%",
              padding: "40px",
              color: "#838196",
            }}
          >
            <p>
              Site Terms and Terms of Sale Last Updated: October 12, 2021. These
              Terms of Sale (“Terms”) apply to your purchase, sale, display and
              use of Founder’s Key non-fungible tokens (“KeyNFTs”). These Terms
              also expressly incorporate any other documents referenced herein
              (such as our
              <a
                href="#/privacypolicy"
                style={{
                  color: "#007bff",
                  textDecoration: "none",
                  backgroundColor: "transparent",
                }}
              >
                {" "}
                Privacy Policy{" "}
              </a>
              ) and govern your access to and use of this site
              www.founderskey.io, as well as any website or mobile app related
              to the KeyNFTs (the “Site”), as well as all content,
              functionality, and services offered on or through the Site,
              including the KeyNFTs. KeyNFTs are designed to provide access to
              benefits and opportunities, such as the Right to Partner Program,
              and may even include special experiences that are linked to
              individual KeyNFTs. These benefits and opportunities are intended
              to be defined more clearly in the future and will change over
              time. Due to the complexity of some of the offerings, we will
              define the specific terms in a separate agreement, the Experience
              Terms, which will be posted on the Site and will govern the usage
              of select benefits and opportunities to be enumerated in the near
              future. Please visit this site regularly for the Experience Terms
              while you hold the KeyNFTs. To the extent there is a conflict
              between these Terms and the Experience Terms, the Experience Terms
              control. These Terms are entered into between you and Non Fungible
              Theory, LLC (“Company,” “we,” or “us”). THE SECTIONS BELOW TITLED
              “BINDING ARBITRATION” AND “CLASS ACTION WAIVER” CONTAIN A BINDING
              ARBITRATION AGREEMENT AND CLASS ACTION WAIVER. THEY AFFECT YOUR
              LEGAL RIGHTS. PLEASE READ THEM CAREFULLY. 1. Reviewing and
              Accepting These Terms Please read these Terms carefully, as they
              set out your rights and responsibilities when you use this Site to
              buy KeyNFTs (the “Services”). When each KeyNFT is sold for the
              first time, the agreement for sale is between the Company and the
              initial purchaser. KeyNFTs may be sold by you to subsequent
              purchasers through any third-party site or platform that supports
              the sale of Ethereum-based non-fungible tokens (“NFTs”). The smart
              contract that governs the KeyNFTs resides immutably on the
              Ethereum blockchain. As such, the Company does not maintain the
              KeyNFTs on the Site. Aside from initially deploying the contract
              to the blockchain, the Company has no control over the transfer,
              storage, or ownership of the KeyNFTs By agreeing to these Terms,
              you hereby certify that you are at least 18 years of age. If you
              do not agree to these Terms, you must not access or use the Site.
              We reserve the right to change or modify these Terms at any time
              and in our sole discretion. You agree and understand that by
              accessing or using the Site following any change to these Terms,
              you are agreeing to the revised Terms and all of the terms
              incorporated therein by reference. 2. Connecting A Cryptocurrency
              Wallet Is Required to Purchase a KeyNFT When you connect your
              cryptocurrency wallet to the Site using a trusted service provider
              of your choice such as MetaMask or Wallet Connect, you accept and
              agree to be bound and abide by these Terms and all of the terms
              incorporated herein by reference. You acknowledge and agree that
              by linking your cryptocurrency wallet, you understand that you are
              solely responsible for maintaining the security of your wallet and
              your control over any wallet-related authentication credentials,
              private or public cryptocurrency keys, NFTs or cryptocurrencies
              that are stored in or are accessible through your wallet. Any
              unauthorized access to your cryptocurrency wallet by third parties
              could result in the loss or theft of KeyNFTs and/or funds held in
              your wallet and any associated wallets, including any linked
              financial information such as bank account(s) or credit card(s).
              We are not responsible for managing and maintaining the security
              of your cryptocurrency wallet nor for any unauthorized access to
              or use of your cryptocurrency wallet. If you notice any
              unauthorized or suspicious activity in your cryptocurrency wallet
              that seems to be related to this Site, please notify us
              immediately. 3. Site Content Ownership Unless otherwise indicated
              in writing by us, the Site, all content, and all other materials
              contained therein, including, without limitation, Our logos, and
              all designs, text, graphics, pictures, information, data,
              software, sound files, other files, and the selection and
              arrangement thereof (collectively, “Site Content”) are the
              proprietary property of Non Fungible Theory, LLC, Impact Theory,
              LLC or our affiliates, licensors, or users, as applicable. You
              shall not (i) sell, transfer, assign, license, sublicense, or
              modify the Site or any Site Content; (ii) reproduce, display,
              publicly perform, make a derivative version of, distribute,
              reverse engineer or otherwise attempt to discover the source code
              of any software contained in or relating to the KeyNFTs, the Site
              or any Site Content; or (iii) otherwise use the Site or any Site
              Content in any way for any public or commercial purpose or in any
              manner other than as expressly permitted in these Terms. We retain
              all right, title and interest and in and to (i) the Site and all
              Site Content; (ii) all improvements and modifications to, and
              derivative works of, the Site and all Site Content; and (iii) all
              intellectual property rights relating to the foregoing. You do not
              obtain any rights to the Site or any Site Content, except for the
              limited right to access and use the Site as expressly permitted
              herein. The trademarks, service marks, and logos used and
              displayed on the Site or in the KeyNFTs may be registered and/or
              unregistered trademarks or service marks of ours (collectively,
              the “Trademarks”). Nothing herein should be construed as granting,
              by implication, estoppel, or otherwise, any license or right to
              use the Trademarks. In particular, use of the Trademarks as part
              of a link to or from any third-party site is prohibited unless
              approved in advance by us in writing. All goodwill generated from
              the use of the Trademarks inures to solely our benefit. 4. Sale
              Stages and KeyNFT Availability There are three KeyNFT tiers, with
              each tier having its own benefits and opportunities as defined
              further in the Experience Terms. There is limited availability of
              KeyNFTs, as follows: Legendary Tier – 2,700 total Heroic Tier –
              7,300 total Relentless Tier – 10,000 total In each case, a small
              number of the KeyNFTs will not be available for purchase because
              they are reserved by us for use as promotional items and gifts. We
              will not sell any of the reserved KeyNFTs for profit to the
              company and all reserved KeyNFTs will be gifted or awarded to or
              won by individuals for their personal use. Our sale of each tier
              of KeyNFTs occurs in three stages. For the Legendary and Heroic
              tiers, the sale will continue as long as the KeyNFTs last. For the
              Relentless tier, the third stage of the sale ends when described
              below. In addition, if all KeyNFTs in a tier are sold during the
              first or second stages, then the sale of the KeyNFTs in that tier
              will end and no other stages of sale will occur. The first sales
              stage is called the “White List” sale and is when the KeyNFTs in a
              particular tier are made available for sale to a restricted group
              of individuals whom we previously notified of eligibility (the
              “White List”). If you were not notified that you are on the White
              List, then you may not purchase KeyNFTs during the first stage of
              sale. No previous purchase or exchange of compensation was
              required for any individual who appears on the White List.
              Individuals on the White List have the opportunity to buy KeyNFTs
              at the price displayed on the Site (the “Reserve Price”). The
              second sales stage is called the “Public Reserve Price” sale and
              occurs immediately following the expiration of the White List
              sale. At this time all members of the public, as well as
              individuals on the White List, may purchase KeyNFTs for the
              Reserve Price. The third sales stage is called the “Auction” and
              occurs immediately following the expiration of the Public Reserve
              Price sale. At this time, all members of the public, as well as
              individuals on the White List, may participate in the Auction.
              During the Auction, the price of the KeyNFTs will drop each hour
              by an amount that is equal to ((Reserve Price x 0.5)/23). The
              KeyNFT price will continue to drop until the price is equal to an
              amount that one-half of that KeyNFT’s Reserve Price. Once the
              KeyNFT price reaches one-half of that KeyNFT’s Reserve Price
              (“Floor Price”), the price will no longer drop. For the Legendary
              and Heroic tiers, the KeyNFTs will remain available at the Floor
              Price, if applicable, until all KeyNFTs are sold. For the
              Relentless tier, the Key NFTs are only available at the Floor
              Price, if applicable, for one hour, after which any Relentless
              tier KeyNFTs that have not been sold, if applicable, will be
              pulled from sale and destroyed immediately and never be available
              for sale again. Each of the sales stages are intended to last for
              approximately twenty-four hours, and the KeyNFT tier White List
              sales will begin on the following dates – please see the Site for
              exact times: Legendary – Wednesday, October 13, 2021 at
              approximately 9AM PT. Heroic – Thursday, October 14, 2021, at
              approximately 9AM PT. Relentless – Friday, October 15, 2021, at
              approximately 9AM PT. Please note that it is possible that due to
              technology and other circumstances, the White List sale stage for
              the Legendary KeyNFTs only may be shorter than twenty-four hours.
              Regardless of when the White List sale of the Legendary KeyNFTs
              begins, the Public Reserve Price sale of the Legendary KeyNFTs
              will begin at approximately 9AM PT on Thursday, October 14, 2021.
              5. Terms of Sale By placing an order on the Site to purchase a
              KeyNFT, you agree that you are submitting a binding offer to
              purchase an KeyNFT or other Service. If you are the initial
              purchaser of a KeyNFT or you are purchasing a Service, then all
              amounts due are to be paid to Non Fungible Theory, LLC. If you are
              not the initial purchaser of a KeyNFT, then amounts may be paid to
              the-then holder of the KeyNFT. You also acknowledge and agree that
              Company receives [10%] of every subsequent sale of a KeyNFT
              (“Royalty”). For example, if you are the initial purchaser, and
              you sell a KeyNFT for $100 to a subsequent purchaser, $10 will
              automatically be transferred to Company and you will receive $90
              (minus any applicable transaction or other third-party fees).
              Company has the right to collect Royalties for KeyNFT sales in
              perpetuity and may use those funds in any manner Company sees fit.
              As such, if you sell a KeyNFT on a third-party NFT marketplace,
              you agree to include a statement substantially similar to the
              following in the description of the KeyNFT: “10% Royalty Applies.
              See Founder’s Key NFT Terms for details.” In addition, when you
              buy a KeyNFT on this Site, you agree to pay all applicable fees
              associated with the transaction and you authorize us to
              automatically charge and collect such fees from your payment. We
              will always display a breakdown of any transaction or other fees
              prior to your purchase of a KeyNFT. No refunds are permitted
              except with respect to any statutory warranties or guaranties that
              cannot be excluded or limited by law. 6. Digital Millennium
              Copyright Act Notice Other than Site Content, all other
              trademarks, product names, and logos on the Site are the property
              of their respective owners and may not be copied, imitated, or
              used, in whole or in part, without the permission of the
              applicable trademark holder. Without limiting the foregoing, if
              you believe that third-party material hosted on the Site infringes
              your copyright or trademark rights, please file a notice of
              infringement by contacting the Copyright Agent listed below. We
              respect the intellectual property rights of others and attempt to
              comply with all relevant laws. We will review all claims of
              copyright infringement received and remove any content deemed to
              have been posted or distributed in violation of any such laws. Our
              designated agent under the Digital Millennium Copyright Act (the
              “Act”) for the receipt of any Notification of Claimed Infringement
              which may be given under that Act is as follows: Directed to
              Copyright Agent at: 1) 9903 Santa Monica Blvd. #1107, Beverly
              Hills, CA 90212 or 2) dmcaagent@impacttheory.com If you believe
              that your work has been copied on the Site in a way that
              constitutes copyright infringement, please provide our agent with
              notice in accordance with the requirements of the Act, including
              (i) a description of the copyrighted work that has been infringed
              and the specific location on the Site where such work is located;
              (ii) a description of the location of the original or an
              authorized copy of the copyrighted work; (iii) your address,
              telephone number and e-mail address; (iv) a statement by you that
              you have a good faith belief that the disputed use is not
              authorized by the copyright owner, its agent or the law; (v) a
              statement by you, made under penalty of perjury, that the
              information in your notice is accurate and that you are the
              copyright owner or authorized to act on the copyright owner’s
              behalf; and (vi) an electronic or physical signature of the owner
              of the copyright or the person authorized to act on behalf of the
              owner of the copyright interest. Counter-Notification Procedures.
              If you believe that material you posted on the Site was removed or
              access to it was disabled by mistake or misidentification, you may
              file a counter-notification with us (a “Counter-Notice”) by
              submitting written notification to our Copyright Agent. Pursuant
              to the Act, the Counter-Notice must include substantially the
              following: (i) your physical or electronic signature; (ii) an
              identification of the material that has been removed or to which
              access has been disabled and the location at which the material
              appeared before it was removed or access disabled; (iii) adequate
              information by which we can contact you (including your name,
              postal address, telephone number, and, if available, email
              address); (iv) a statement under penalty of perjury by you that
              you have a good faith belief that the material identified above
              was removed or disabled as a result of a mistake or
              misidentification of the material to be removed or disabled; (v) a
              statement that you will consent to the jurisdiction of the Federal
              District Court for the judicial district in which your address is
              located (or if you reside outside the United States for any
              judicial district in which the Site may be found) and that you
              will accept service from the person (or an agent of that person)
              who provided the Site with the complaint at issue. The Act allows
              us to restore the removed content if the party filing the original
              notice does not file a court action against you within ten
              business days of receiving the copy of your Counter-Notice. Please
              be aware that if you knowingly materially misrepresent that
              material or activity on the Site was removed or disabled by
              mistake or misidentification, you may be held liable for damages
              (including costs and attorneys fees) under Section 512(f) of the
              Act. 7. Intellectual Property in KeyNFTs With respect to the
              KeyNFTs, each purchaser of a KeyNFT is granted an exclusive,
              limited license to such KeyNFT and its content to access, use, or
              store such KeyNFT and its content solely for their personal,
              non-commercial purposes. KeyNFTs are a limited-edition digital
              creation based upon content that may be trademarked and/or
              copyrighted by Company. Unless otherwise specified, your purchase
              of a KeyNFT does not give you the right to publicly display,
              perform, distribute, sell or otherwise reproduce the KeyNFT or its
              content for any commercial purpose. You further agree that you are
              not receiving any copyright interest in the KeyNFT or its content,
              and indeed, you agree that Company may sell, license, modify,
              display, broadcast and create derivative works based upon your
              KeyNFT or its content. Any commercial exploitation of the KeyNFT
              could subject you to claims of copyright infringement. If you sell
              a KeyNFT through the Site, you agree that you will not have any
              claims against us for any breach of these Terms by a purchaser. If
              you purchase a KeyNFT on the Site, you hereby agree to hold us and
              the seller of such KeyNFT harmless from and against any and all
              violations or breaches of these Terms. If you are unsure whether a
              contemplated use of the Site Content or a KeyNFT and its content
              would violate these Terms, please contact us at
              dmcaagent@impacttheory.com. 8. Taxes: We are not responsible for
              determining the withholding, sales, use, value added, transfer or
              other taxes, together with any interest and penalties imposed with
              respect thereto (“Taxes”), that may apply to transactions on this
              Site. You agree that you are solely responsible for determining
              what, if any, Taxes, duties, and assessments (except taxes on our
              net income) now or hereafter claimed or imposed by any
              governmental authority associated with purchases or sales of
              KeyNFTs or your use of the Site. Unless otherwise indicated on an
              applicable invoice, amounts due on this Site are exclusive of
              sale, use, value added or similar Taxes (“Sales Taxes”). This
              means that Sales Taxes become your sole responsibility. Upon our
              request, you agree to promptly provide a properly executed
              Internal Revenue Service Form W-9 or applicable Internal Revenue
              Service W-8 and any other tax form that is reasonably required by
              us so to comply with our tax reporting obligations. By agreeing to
              these Terms, you agree you: (a) will pay or reimburse us for all
              Taxes and Sales Taxes assessments of any jurisdiction, including
              value added taxes and taxes as required by international tax
              treaties, customs or other import or export taxes, and amounts
              levied in lieu thereof based on charges set, services performed or
              payments made hereunder, as are now or hereafter may be imposed
              under the authority of any national, state, local or any other
              taxing jurisdiction; and (b) will not be entitled to deduct the
              amount of any such Taxes, Sales Taxes, duties or assessments from
              payments made to us pursuant to these Terms. 9. Privacy You
              acknowledge and agree to the collection, use, and disclosure of
              your personal information in accordance with our{" "}
              <a
                href="#/privacypolicy"
                style={{
                  color: "#007bff",
                  textDecoration: "none",
                  backgroundColor: "transparent",
                }}
              >
                [Privacy Policy]{" "}
              </a>
              , which is incorporated into these Terms. 10. Modifications You
              agree and understand that we may modify part or all of this Site
              or the Services without notice, and that we may update these Terms
              and any other document incorporated by reference therein at any
              time, and we have no obligation to inform you of changes to the
              Terms. 11. Termination We reserve the right to discontinue,
              suspend or terminate support for the added experiences and
              opportunities, including the Right to Partner Program, that will
              be described in the Experience Terms, at any time. Notice will be
              provided through the Company’s Discord channel of such
              discontinuation, suspension, or termination to holders of the
              KeyNFTs, and such notice will be provided in advance whenever
              possible. 12. Risks Inherent In Blockchain Transactions and
              KeyNFTs Please note the following risks in accessing, purchasing,
              selling or using KeyNFTs, the purchase of which is intended to be
              primarily for utility and engagement: • The price and liquidity of
              blockchain assets, including KeyNFTs, are extremely volatile and
              may be subject to large fluctuations. • Fluctuations in the price
              of other digital assets could materially and adversely affect
              KeyNFTs, which may also be subject to significant price
              volatility. • Legislative and regulatory changes or actions at the
              state, federal, or international level may adversely affect the
              use, transfer, exchange, and value of KeyNFTs. • KeyNFTs are not
              legal tender and are not backed by any government. • KeyNFTs are
              not securities and may lose value. • Transactions in KeyNFTs may
              be irreversible, and, accordingly, losses due to fraudulent or
              accidental transactions may not be recoverable. • Some
              transactions in KeyNFTs shall be deemed to be made when recorded
              on a public ledger, which is not necessarily the date or time that
              you initiated the transaction. • The value of KeyNFTs may be
              derived from the continued willingness of market participants to
              exchange fiat currency or digital assets for KeyNFTs, which may
              result in the potential for permanent and total loss of value of a
              particular KeyNFT should the market for that KeyNFT disappear. You
              acknowledge that the NFT ecosystem is in its infancy and as such,
              there could be risks that are unknown to us at this time. You
              agree and understand that you are solely responsible for
              determining the nature, potential value, suitability, and
              appropriateness of these risks for yourself, and that we do not
              give advice or recommendations regarding KeyNFTs, including the
              suitability and appropriateness of, and investment strategies for,
              KeyNFTs. You agree and understand that you access and use this
              Site at your own risk; however, this brief statement does not
              disclose all of the risks associated with KeyNFTs and other
              digital assets. You agree and understand that we will not be
              responsible for any communication failures, disruptions, errors,
              distortions or delays you may experience when using KeyNFTs,
              however caused, including when you are linking your cryptocurrency
              wallet to our Site. 13. Disclaimers EXCEPT AS EXPRESSLY PROVIDED
              TO THE CONTRARY IN A WRITING BY NON FUNGIBLE THEORY, LLC, THE SITE
              AND ANY SITE CONTENT CONTAINED THEREIN, AND ANY AND ALL KEYNFTS
              LISTED THEREIN ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS
              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR
              IMPLIED. WE (AND OUR SUPPLIERS AND AFFILIATES) MAKE NO WARRANTY
              THAT THE SITE WILL (1) MEET YOUR REQUIREMENTS; (2) BE AVAILABLE ON
              AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; OR (3) BE
              ACCURATE, RELIABLE, COMPLETE, LEGAL, OR SAFE. WE WILL NOT BE
              LIABLE FOR ANY LOSS OF ANY KIND FROM ANY ACTION TAKEN OR TAKEN IN
              RELIANCE ON MATERIAL OR INFORMATION, CONTAINED ON THE SITE. WE DO
              NOT REPRESENT OR WARRANT THAT SITE CONTENT IS ACCURATE, COMPLETE,
              RELIABLE, CURRENT OR ERROR-FREE. WHILE WE ATTEMPT TO MAKE YOUR
              ACCESS TO AND USE OF THE SITE AND SITE CONTENT SAFE, WE CANNOT AND
              DO NOT REPRESENT OR WARRANT THAT THE SITE, SITE CONTENT, ANY
              KEYNFTS LISTED ON OUR SITE OR OUR SERVERS ARE FREE OF VIRUSES OR
              OTHER HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE SECURITY OF ANY
              DATA THAT YOU DISCLOSE ONLINE. YOU ACCEPT THE INHERENT SECURITY
              RISKS OF PROVIDING INFORMATION AND DEALING ONLINE OVER THE
              INTERNET AND WILL NOT HOLD US RESPONSIBLE FOR ANY BREACH OF
              SECURITY UNLESS IT IS DUE TO OUR GROSS NEGLIGENCE. WE WILL NOT BE
              RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND TAKE NO
              RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR, ANY USE OF
              KEYNFTS INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES OR CLAIMS
              ARISING FROM: (A) USER ERROR SUCH AS FORGOTTEN PASSWORDS,
              INCORRECTLY CONSTRUCTED TRANSACTIONS, OR MISTYPED ADDRESSES; (B)
              SERVER FAILURE OR DATA LOSS; (C) CORRUPTED CRYPTOCURRENCY WALLET
              FILES; (D) UNAUTHORIZED ACCESS TO APPLICATIONS OR THE SITE; (E)
              ANY UNAUTHORIZED THIRD PARTY ACTIVITIES, INCLUDING WITHOUT
              LIMITATION THE USE OF VIRUSES, PHISHING, BRUTE FORCING OR OTHER
              MEANS OF ATTACK AGAINST THE SITE OR KEYNFTS. KEYNFTS ARE
              INTANGIBLE DIGITAL ASSETS. THEY EXIST ONLY BY VIRTUE OF THE
              OWNERSHIP RECORD MAINTAINED IN THE ETHEREUM NETWORK. ANY TRANSFER
              OF TITLE THAT MIGHT OCCUR IN ANY UNIQUE DIGITAL ASSET OCCURS ON
              THE DECENTRALIZED LEDGER WITHIN THE ETHEREUM PLATFORM IS NOT IN
              OUR CONTROL. WE DO NOT GUARANTEE THAT WE OR OUR SUPPLIERS OR
              AFFILIATES CAN EFFECT THE TRANSFER OF TITLE OR RIGHT IN ANY KEYNFT
              . We are not responsible for sustained casualties due to
              vulnerability or any kind of failure, abnormal behavior of
              software (e.g., wallet, smart contract), blockchains or any other
              features of the KEYNFTs. We are not responsible for casualties due
              to late report by developers or representatives (or no report at
              all) of any issues with the blockchain supporting KEYNFTs
              including forks, technical node issues or any other issues having
              fund losses as a result. Nothing in these Terms shall exclude or
              limit liability of either party for fraud, death or bodily injury
              caused by negligence, violation of laws, or any other activity
              that cannot be limited or excluded by legitimate means. SOME
              JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES IN
              CONTRACTS WITH CONSUMERS, SO THE ABOVE EXCLUSION MAY NOT APPLY TO
              YOU. 14. Limitation of Liability TO THE FULLEST EXTENT PERMITTED
              BY LAW, IN NO EVENT WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY
              FOR ANY LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
              INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES ARISING FROM THESE TERMS,
              THE SITE, SITE CONTENT, THE SERVICES OR THIRD PARTY SITES AND
              PRODUCTS, OR FOR ANY DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF
              PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE,
              LOSS OF GOODWILL, OR LOSS OF DATA, WHETHER CAUSED BY TORT
              (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF
              FORESEEABLE AND EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGES. ACCESS TO, AND USE OF, THE SITE, SITE CONTENT, THE
              SERVICES OR THIRD PARTY SITES AND PRODUCTS ARE AT YOUR OWN
              DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY
              DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE DEVICE OR LOSS OF DATA
              RESULTING THEREFROM. IF YOU HAVE AN ISSUE WITH ANY INTERACTION OR
              TRANSACTION THAT YOU ENTERED INTO WITH ANOTHER USER OF THE SITE,
              YOU MUST ADDRESS THAT ISSUE DIRECTLY WITH THE OTHER USER AND NOT
              WITH US – WE HAVE NO OBLIGATION TO ASSIST IN ANY OF THESE
              DISPUTES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED
              HEREIN, IN NO EVENT SHALL OUR MAXIMUM AGGREGATE LIABILITY ARISING
              OUT OF OR IN ANY WAY RELATED TO THIS AGREEMENT, THE ACCESS TO AND
              USE OF THE SITE, SITE CONTENT, KEYNFTS, OR ANY SERVICES PURCHASED
              ON THE SITE EXCEED THE DIRECT DAMAGES IN EXCESS OF AN AMOUNT EQUAL
              TO THE FEES THAT WE HAVE COLLECTED FROM YOU IN THE THREE (3)
              MONTHS IMMEDIATELY PRECEDING THE CLAIM, EVEN IF WE HAVE BEEN
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. 15. Indemnification
              You agree to defend, indemnify, and hold us and our officers,
              directors, employees, successors, licensees, and assigns harmless
              from and against any claims, actions, or demands, including,
              without limitation, reasonable legal and accounting fees, arising
              or resulting from (i) breach of any of your representations,
              warranties or other obligations under these Terms; (ii) your
              misuse of the Site; (iii) your gross negligence or willful
              misconduct; (iv) any transaction that you enter into with another
              user of the Site; or (v) any actual or alleged infringement or
              misappropriation of third party intellectual property rights
              related to content you provide to us. We shall provide notice to
              you of any such claim, suit, or proceeding and shall assist you,
              at your expense, in defending any such claim, suit, or proceeding.
              We reserve the right, at your expense, to assume the exclusive
              defense and control of any matter that is subject to
              indemnification under this section. In such case, you agree to
              cooperate with any reasonable requests assisting our defense of
              such matter. 16. Governing Law These Terms, your rights and
              obligations, and all actions contemplated by, arising out of or
              related to these Terms shall be governed by the laws of the State
              of California, as if these Terms are a contract wholly entered
              into and wholly performed within the State of California. YOU
              UNDERSTAND AND AGREE THAT YOUR USE OF THIS SITE AS CONTEMPLATED BY
              THESE TERMS SHALL BE DEEMED TO HAVE OCCURRED IN THE STATE OF
              CALIFORNIA AND BE SUBJECT TO THE INTERNAL LAWS OF THE STATE OF
              CALIFORNIA WITHOUT REGARD TO ITS CONFLICTS OF LAWS PROVISIONS. 17.
              BINDING ARBITRATION AGREEMENT This Section 17 constitutes the
              “Arbitration Agreement.” A. Subject to sub-section B below, in the
              event of a dispute arising under or relating to these Terms
              (“Dispute”), either party may elect to finally and exclusively
              resolve the dispute by binding arbitration governed by the Federal
              Arbitration Act (“FAA”). Any election to arbitrate, at any time,
              shall be final and binding on the other party. IF EITHER PARTY
              CHOOSES ARBITRATION, NEITHER PARTY SHALL HAVE THE RIGHT TO
              LITIGATE SUCH CLAIM IN COURT OR TO HAVE A JURY TRIAL, EXCEPT
              EITHER PARTY MAY BRING ITS CLAIM IN ITS LOCAL SMALL CLAIMS COURT,
              IF PERMITTED BY THAT SMALL CLAIMS COURT RULES AND IF WITHIN SUCH
              COURT’S JURISDICTION. ARBITRATION IS DIFFERENT FROM COURT, AND
              DISCOVERY AND APPEAL RIGHTS MAY ALSO BE LIMITED IN ARBITRATION.
              All Disputes will be resolved before a neutral arbitrator selected
              jointly by the parties, whose decision will be final, except for a
              limited right of appeal under the FAA. The arbitration shall be
              commenced and conducted by JAMS pursuant to its then current
              Comprehensive Arbitration Rules and Procedures and in accordance
              with the Expedited Procedures in those rules, or, where
              appropriate, pursuant to JAMS’ Streamlined Arbitration Rules and
              Procedures. All applicable JAMS’ rules and procedures are
              available at the JAMS website www.jamsadr.com. Each party will be
              responsible for paying any JAMS filing, administrative and
              arbitrator fees in accordance with JAMS rules. Judgment on the
              arbitrator’s award may be entered in any court having
              jurisdiction. This clause shall not preclude parties from seeking
              provisional remedies in aid of arbitration from a court of
              appropriate jurisdiction. The arbitration may be conducted in
              person, through the submission of documents, by phone, or online.
              If conducted in person, the arbitration shall take place in the
              United States county where you reside. The parties may litigate in
              court to compel arbitration, to stay a proceeding pending
              arbitration, or to confirm, modify, vacate or enter judgment on
              the award entered by the arbitrator. The parties shall cooperate
              in good faith in the voluntary and informal exchange of all
              non-privileged documents and other information (including
              electronically stored information) relevant to the Dispute
              immediately after commencement of the arbitration. Nothing in
              these Terms will prevent us from seeking injunctive relief in any
              court of competent jurisdiction as necessary to protect our
              proprietary interests. B. CLASS ACTION WAIVER -- You agree that
              any arbitration or proceeding shall be limited to the Dispute
              between us and you individually. To the full extent permitted by
              law, (i) no arbitration or proceeding shall be joined with any
              other; (ii) there is no right or authority for any Dispute to be
              arbitrated or resolved on a class action-basis or to utilize class
              action procedures; and (iii) there is no right or authority for
              any Dispute to be brought in a purported representative capacity
              on behalf of the general public or any other persons. YOU AGREE
              THAT YOU MAY BRING CLAIMS AGAINST US ONLY IN YOUR INDIVIDUAL
              CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED
              CLASS OR REPRESENTATIVE PROCEEDING. C. SEVERABILITY OF ARBITRATION
              AGREEMENT. Except as provided herein, if any part or parts of this
              Arbitration Agreement are found under the law to be invalid or
              unenforceable, then such specific part or parts shall be of no
              force and effect and shall be severed and the remainder of the
              Arbitration Agreement shall continue in full force and effect. D.
              SURVIVAL OF ARBITRATION AGREEMENT. This Arbitration Agreement will
              survive the termination of your relationship with us. 18.
              Severability of Terms If any term, clause, or provision of these
              Terms is held invalid or unenforceable, then that term, clause, or
              provision shall be severable from these Terms and will not affect
              the validity or enforceability of any remaining part of that term,
              cause, or provision, or any other terms, clause, or provision of
              these Terms. 19. Entire Agreement These Terms comprise the entire
              agreement between you and us relating to your access to and use of
              the Site, Site Content and any KeyNFTs you have purchased, and
              supersede any and all prior discussions agreements, and
              understandings of any kind. Except as otherwise provided herein,
              these Terms are intended solely for the benefit of the parties and
              are not intended to confer third party beneficiary rights upon any
              other person or entity.
            </p>
          </div>
        </main>
      </Layout>
    );
}